<template>
  <div class="banner-left">
    <button @click="toggle()" class="banner-left__toggle">
      <font-awesome-icon icon="bars" />
    </button>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {};
  },

  methods: {
    ...mapActions({ toggleSidebar: "ui/switchToggle" }),

    toggle() {
      this.toggleSidebar();
    }
  }
};
</script>

<style lang="sass" scoped>

.banner-left
    padding: 10px

    &__toggle
      outline: none
      margin-right: 10px
      color: $c-white

</style>